<ng-container *ngIf="isAuthenticated">

  <app-topbar></app-topbar>

  <div class="mc-frame">

    <!-- Desktop: sidebar fija. En mobile se oculta y navega la tab bar. -->
    <div class="mc-side-fija">
      <app-sidebar (cerrarSesion)="logout()"></app-sidebar>
    </div>

    <main class="mc-main">
      <router-outlet></router-outlet>
    </main>

  </div>

  <!-- Mobile: navegacion inferior. Se oculta sola en desktop. -->
  <app-tabbar (cerrarSesion)="logout()"></app-tabbar>

</ng-container>
